<template>
    <div class="fixed-filter-container">
        <div class="first-row">
            <v-select
                v-for="item in firstRowOfFilterObjects"
                :items="item.items"
                :placeholder="item.placeholder"
                item-text="value"
                item-value="id"
                :key="item.id"
                v-model="filtersObj[item.modelName]"
                v-on:change="item.onChange ? item.onChange() : null"
            ></v-select>
        </div>
        <div class="second-row">
            <div class="content-wrapper">
                <div class="filter-column" v-for="(item, index) in secondRowOfFilterObjects" :key="index">
                    <button v-if="item.type === 'button'" class="btn-secondary btn-sort" :class="[item.isActive ? 'active' : '', item.className]" v-on:click="() => item.onClick(item.className)">
                        {{ item.text }}
                        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 0.603516L0 5.85806H4V15.6035H6V5.85806H10L5 0.603516Z"/>
                        </svg>
                    </button>
                    <v-select
                        v-if="item.type === 'select'"
                        :items="item.items"
                        :placeholder="item.placeholder"
                        item-text="value"
                        item-value="id"
                        v-model="filtersObj[item.modelName]"
                        v-on:change="item.onChange ? item.onChange() : null"
                    ></v-select>
                </div>
            </div>
            <div class="buttons-wrapper">
                <button class="btn-secondary filter-btn" v-on:click="() => onApplyFilters()">{{ $t('apply') }}</button>
                <button class="btn-secondary clear-filter" v-on:click="() => onResetFilters()">{{ $t('clear') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterComponent",
    props: ['firstRowOfFilterObjects', 'secondRowOfFilterObjects', 'filtersObj', 'onApplyFilters', 'onResetFilters']
}
</script>

<style>
.portfolio-wrapper .fixed-filter-container {
    width: 100%;
    /*position: absolute;*/
    /*top: 140px;*/
}

.portfolio-wrapper .fixed-filter-container {
    margin-top: 20px;
    margin-bottom: 50px;
}

.portfolio-wrapper .first-row {
    display: flex;
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 20px;
}

.portfolio-wrapper .first-row .theme--light.v-input:not(.v-input--is-disabled) input {
    border-bottom: 0;
}

.portfolio-wrapper .first-row .v-text-field__details {
    display: none;
}

.portfolio-wrapper .first-row .v-select__selections {
    line-height: 35px;
    height: 50px;
    background: #fff;
    padding-left: 15px;
    margin-top: 20px;
    border-bottom: 1px solid rgb(178, 178, 178);
}

.portfolio-wrapper .first-row .v-text-field .v-input__append-inner {
    position: static;
    z-index: 0;
    right: 0;
    top: 0;
    align-self: inherit;
}

.portfolio-wrapper .v-text-field {
    padding-left: 10px;
    padding-right: 10px;
}

.myprofile-wrapper .portfolio-wrapper .fixed-filter-container .v-text-field .v-input__append-inner {
    top: 10px;
}

.myprofile-wrapper .portfolio-wrapper .fixed-filter-container .v-select__selections {
    background: var(--semi-white);
    padding-left: 0;
    margin-top: 0;
}

.myprofile-wrapper .portfolio-wrapper .fixed-filter-container .v-select__selections input {
    height: 50px;
    width: 50px;
    background: transparent;
    z-index: 2;
    color: #000;
}

.portfolio-wrapper .fixed-filter-container .second-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.portfolio-wrapper .fixed-filter-container .second-row .filter-btn,
.portfolio-wrapper .fixed-filter-container .second-row .clear-filter {
    font-weight: 500;
    color: var(--true-black);
    border-color: var(--true-black)
}

.portfolio-wrapper .second-row {
    display: flex;
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 20px;
}

.portfolio-wrapper .second-row .v-text-field {
    width: 200px;
    padding-left: 0;
    padding-right: 0;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper {
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
}

.portfolio-wrapper .fixed-filter-container .second-row .buttons-wrapper {
    padding-left: 10px;
    padding-right: 10px;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .filter-column + .filter-column {
    margin-left: 18px;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort {
    background: transparent;
    border: 2px solid #004F7F;
    border-radius: 32px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.88);
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort svg {
    fill: #000;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort:hover {
    background: #004F7F;
    color: #FFF;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort:hover svg,
.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort.active svg {
    color: #FFF;
    fill: #FFF;
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort.descending svg {
    transform: rotate(180deg);
}

.portfolio-wrapper .fixed-filter-container .second-row .content-wrapper .btn-sort.active {
    background: #004F7F;
    color: #FFF;
}

</style>
